export default "__VITE_ASSET__C1B6rP8M__"